<template>
  <div id="main-page">
    <div class="container">
      <app-bar
        title="Pilih Dokter Poli"
        :previousLink="previousLink" />

      <div class="row">
        <div class="col-md-4">
          <div class="input-group mb-3 rounded-pill">
            <input
              type="text"
              class="form-control bg-transparent"
              placeholder="Cari dokter..."
              name="search"
              v-model="keyword"
              autocomplete="off">
            <span class="input-group-text bg-transparent border-0">
              <div
                class="box-icon"
                type="button"
                @click="keyword = ''"
              >
                <i class="ri-close-circle-fill fs-14 color-neutral-700"></i>
              </div>
            </span>
          </div>
        </div>
      </div>

      <Loading v-if="loading.listDoctorPoli && filteredDoctors.length < 1" />
      <div v-else-if="filteredDoctors.length">
        <div class="list-group list-group-flush">
          <button
            v-for="doctor in filteredDoctors"
            :key="doctor.id"
            type="button"
            class="list-group-item list-group-item-action py-3 d-flex align-items-center gap-3"
            @click="selectDoctor(doctor)">
            <div class="avatar flex-shrink-0">
              <img :src="doctor.foto_profile || require('@/assets/user-placeholder.png')" alt="doctor" />
            </div>
            <div class="flex-grow-1 text-start">
              <div class="fw-700 fs-14 color-neutral-900">{{ doctor.nama_dokter }}</div>
              <div class="fw-400 fs-12 color-neutral-600 mt-1">{{ doctor.kode_dokter || '-' }}</div>
            </div>
          </button>
        </div>
      </div>
      <div v-else class="not-found d-flex flex-column text-center pb-5 pt-5">
        <div class="image-wrapper">
          <img src="@/assets/icon/empty.png" alt="">
        </div>
        <p class="text-title-active fw-bold fs-18 lh-28">Tidak ada hasil ditemukan</p>
        <div class="text-body-light d-flex justify-content-center">
          <p class="fw-400 fs-14 lh-24 mb-0">Maaf dokter yang anda cari tidak ditemukan.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import Loading from '@/components/utility/Loading'
import { listDoctorPoli, getListDoctorPoli, loading, selectedDoctorPoli, selectedPoli, selectedBranchPoli } from '@/core/poli'
import { computed, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
  components: {
    AppBar, Loading
  },
  setup () {
    const keyword = ref('')
    const router = useRouter()
    const route = useRoute()

    const previousLink = computed(() => {
      if (route.query && route.query.poli && route.query.cabang) {
        return { name: 'CheckoutPoli', query: { ...route.query } }
      }
      return { name: 'SelectBranchPoli' }
    })

    const filteredDoctors = computed(() => {
      return listDoctorPoli.value ? listDoctorPoli.value.filter((data) => {
        return keyword.value.toLowerCase().split(' ').every(v => (data.nama_dokter || '').toLowerCase().includes(v))
      }) : []
    })

    const selectDoctor = (doctor) => {
      selectedDoctorPoli.value = doctor
      router.push({
        name: 'CheckoutPoli',
        query: { ...route.query, dokter: doctor.id }
      })
    }

    onMounted(() => {
      if (!selectedPoli.value) {
        return router.push({ name: 'SelectPoli' })
      }

      if (!selectedBranchPoli.value) {
        return router.push({ name: 'SelectBranchPoli' })
      }

      getListDoctorPoli()
    })

    return {
      keyword,
      loading,
      filteredDoctors,
      selectDoctor,
      previousLink
    }
  }
}
</script>

<style lang="scss" scoped>
#main-page {
  @media (max-width: 520px) {
    padding-bottom: 3.25rem;
  }
}

.input-group {
  border: 1px solid #E2E8F0;

  .form-control, .input-group-text {
    height: 34px;
  }

  .form-control:focus{
    box-shadow: none;
  }

  .form-control::placeholder {
    color: #A0AEC0;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
  }
}

.list-group-item {
  border-left: 0;
  border-right: 0;
}

.avatar {
  width: 56px;
  height: 56px;
  border: 2px solid #37C684;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.not-found {
  .image-wrapper {
    margin-bottom: 24px;
  }

  .text-title-active {
    margin-bottom: 4px;
  }
}
</style>
